import React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { EditorModeTab } from "../constants";
import CodeFormEditor from "./codeFormEditor";
import FormPreview from "./formPreview";
import VisualFormEditor from "./visualFormEditor";

type EditorModeRendererProps = {
  tabSelected: EditorModeTab;
};

const EditorModeRenderer: React.FC<EditorModeRendererProps> = (props) => {
  const { tabSelected } = props;

  return (
    <AutoSizer>
      {({ height, width }) => (
        <div style={{ height, width }}>
          {tabSelected === EditorModeTab.Preview && <FormPreview />}
          {tabSelected === EditorModeTab.VisualEditor && <VisualFormEditor />}
          {tabSelected === EditorModeTab.CodeEditor && <CodeFormEditor />}
        </div>
      )}
    </AutoSizer>
  );
};

export default EditorModeRenderer;
